import React, { useContext, useEffect } from 'react'
import './SubmitPhoto.css'
import { checkBtnIcon, crossBtnIcon } from '../../../../images/btnIcons'
import LanguageTranslater from '../../../HOC/LanguageTranslater'
import { SpeakerContext } from '../../../../context/SpeakerContext'
import { cross } from '../../../../images/images'

const SubmitPhoto = ({ photo, submitSelfie, retake, translate, selfieSubmitErr, showSubmitSelfieButton, livelinessErr, errMsg }) => {
    const { handleAudioIconDisplay } = useContext(SpeakerContext)
    useEffect(() => {
        handleAudioIconDisplay(false)
        return () => {
            handleAudioIconDisplay(true)
        }
    }, [])
    return (
        <div className="submitPhotoWrapper">
            {/* <div className="statusBar step4"></div> */}
            <div className="submitPhotoInner">
                <div className="heading">{translate("Looks good")}</div>
                <p>{translate("photo_used_in_proposal_form")}</p>
                <div className="photoFrame">
                    <div className={`borderFrame ${livelinessErr ? 'err-case' : ''}`}>
                        <img src={photo} alt="photo_frame" />
                    </div>
                    {selfieSubmitErr && <div className='error-msg-txt' >
                        <small>{selfieSubmitErr}</small>
                    </div>}
                    {livelinessErr && <div className='error-msg-txt' >
                        <small>{errMsg}</small>
                        <div className="selfie-msg-cntnr">
                            <p className="err-msg">
                                {translate("Liveliness Detection")}
                            </p>
                            <img src={cross} height="15px" width="15px" />
                        </div>
                    </div>}
                </div>

                <div className="buttonWrapper">
                    <button onClick={(e) => retake(e)} className="btn btnClose"><img src={crossBtnIcon} alt="icon" /></button>
                    {showSubmitSelfieButton && <button onClick={submitSelfie} className="btn btnGreenCircle"><img src={checkBtnIcon} alt="icon" /></button>}
                    {/* <button className="btn btnClose"></button> */}
                </div>
            </div>
        </div>
    )
}

export default LanguageTranslater(SubmitPhoto)
